import React from 'react';
import { Card, CardContent, Typography, LinearProgress, Box } from '@mui/material';

interface PortfolioScoreCardProps {
  score: number; // 0-1
}

const getScoreLabel = (score: number) => {
  if (score >= 0.7) return 'Solide';
  if (score >= 0.4) return 'Moyen';
  return 'Faible';
};

const PortfolioScoreCard: React.FC<PortfolioScoreCardProps> = ({ score }) => (
  <Card variant="outlined" sx={{ mb: 2, minWidth: 200 }}>
    <CardContent>
      <Typography variant="subtitle2" color="text.secondary">
        Score du portefeuille
      </Typography>
      <Box display="flex" alignItems="center" mt={1}>
        <LinearProgress
          variant="determinate"
          value={score * 100}
          sx={{ width: '80%', height: 10, borderRadius: 5, mr: 2 }}
          color={score >= 0.7 ? 'success' : score >= 0.4 ? 'warning' : 'error'}
        />
        <Typography variant="body2" fontWeight="bold">
          {getScoreLabel(score)}
        </Typography>
      </Box>
    </CardContent>
  </Card>
);

export default PortfolioScoreCard;
